export interface NavLink {
  label: string;
  path: string;
}

/**
 * The page has five sections and the header names four of them. Pricing is in
 * the list because "what does it cost" is the question a visitor arrives with,
 * and the old site made them go to a store to find the answer.
 */
export const NAV_LINKS: NavLink[] = [
  { label: $localize`:@@navFeatures:Features`, path: '#features' },
  { label: $localize`:@@navPrivacy:Privacy`, path: '#privacy' },
  { label: $localize`:@@navPricing:Pricing`, path: '#pricing' },
  { label: $localize`:@@navFaqs:Questions`, path: '#faqs' },
];

export interface SiteLocale {
  code: string;
  /** The language's name in that language. Never translated. */
  label: string;
  /** The path this locale is served from. */
  path: string;
}

/**
 * The five languages the *site* ships in.
 *
 * The app is offered in the same five, so picking a language here picks the
 * language of the page, of the drawn screens, and of the app you download.
 *
 * Labels stay in their own language. A language picker that translates its own
 * options is useless to the person scanning it for their language.
 */
export const SITE_LOCALES: SiteLocale[] = [
  { code: 'en', label: 'English', path: '/' },
  { code: 'fr', label: 'Français', path: '/fr' },
  { code: 'de', label: 'Deutsch', path: '/de' },
  { code: 'it', label: 'Italiano', path: '/it' },
  { code: 'es', label: 'Español', path: '/es' },
];
